exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".blink-dot[data-v-6e618dda]{font-size:10px;animation:blink-6e618dda 1s infinite}@keyframes blink-6e618dda{0%{opacity:1}50%{opacity:.2}to{opacity:1}}", ""]);

// exports
